import { createContext, useContext } from 'react';
import type { MidiHit, MidiRawNote, MidiStatus } from '../hooks/useMidiDrums';

export interface MidiContextValue {
  status: MidiStatus;
  deviceName: string;
  lastHit: MidiHit | null;
  lastRawNote: MidiRawNote | null;
  scan: () => void;
}

export const MidiContext = createContext<MidiContextValue>({
  status: 'idle',
  deviceName: '',
  lastHit: null,
  lastRawNote: null,
  scan: () => {},
});

export function useDrumMidi() {
  return useContext(MidiContext);
}
